import { Button, Divider, Typography } from "@mui/material";

const ListingTermsBlock = ({ isBioShort, setIsBioShort, logo, terms }) => {
  const isLong = terms?.length > 300;
  const displayText = isBioShort
    ? (terms || "").slice(0, 300) + (isLong ? "..." : "")
    : terms;

  return (
    <Typography
      component={"p"}
      variant="body"
      color={"textSecondary"}
      textAlign="center"
    >
      <Divider sx={{ marginBottom: "1.5rem" }} />
      {logo && (
        <img src={logo} alt="vendor-logo" style={{ marginBottom: "5px" }} />
      )}{" "}
      <Typography variant="body" color="GrayText">
        {displayText}
      </Typography>
      {isLong && (
        <Button
          sx={{
            padding: "0 !important",
            marginLeft: "5px",
            textTransform: "capitalize",
            textDecoration: "underline",
          }}
          color="secondary"
          variant="text"
          onClick={() => setIsBioShort((v) => !v)}
        >
          {isBioShort ? "Show more" : "Show Less"}
        </Button>
      )}
    </Typography>
  );
};

export default ListingTermsBlock;
